module.exports = __webpack_public_path__ + "img/canada-neoplasm-female.3f01e45a.png";